import { getToken } from 'helpers/auth';

const isSet = value => value !== null && typeof value !== 'undefined';

const queryParams = params => {
  return Object.keys(params)
    .map(k => (isSet(params[k]) ? encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) : null))
    .filter(value => value !== null)
    .join('&');
};

const REMOVE_SLASHES = /^\/|\/$/g;
const removeSlashes = string => {
  return string.replace(REMOVE_SLASHES, '');
};

export function uploadUrl(orderUID, uploadUID, token, user) {
  return API_HOST + 'media/get/' + orderUID + '/' + uploadUID + '?token=' + token + '&user=' + user;
}

export function request(url, options = {}) {
  // Body
  if (options && options.body) {
    options.method = options.method || 'POST';

    const body = options.body;
    options.body = new FormData();
    Object.keys(body).forEach(key => {
      if (isSet(body[key])) {
        options.body.append(key, body[key]);
      }
    });
  }

  if (options.params) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + queryParams(options.params);
    delete options.params;
  }

  // p('Requesting: ', url, options.params);
  return fetch(url, options)
    .then(response => {
      if (!response.ok) {
        throw response.status;
      }

      return response.json();
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export default (endpoint, options = {}) => {
  const doAuth = options.auth === true;

  let url = API_HOST;
  url += removeSlashes(endpoint);

  // Set useragent
  options.headers = {
    ...(options.headers || {}),
  };

  // Do everything through Auth if available
  if (doAuth) {
    const accessToken = getToken();
    options.headers.Authorization = `Bearer ${accessToken}`;
  }

  return request(url, options);
};



// WEBPACK FOOTER //
// ./app/helpers/api.js